import React from 'react'
import { useLazyGetTaskListDetailsOfMemberByIdQuery } from '../services/MembershipTaskList/MembershipTaskListServiceApi';


/**
 * Custom hook for fetching board committee list.
 * 
 * @returns {{
 *   fetchTaskListDetails: (params: { memberId: Number, taskListId: Number }) => void,
 *   TaskListDetailsData: Array,
 *   isTaskListDetailsLoading: boolean,
 *   isTaskListDetailsSuccess: boolean,
 *   isTaskListDetailsError: boolean,
 *   TaskListDetailsError: any,
 * }}
 */
export const useGetTaskListDetailOfMemberById = () => {

    const [triggerApi, apiState] = useLazyGetTaskListDetailsOfMemberByIdQuery();

    // Return aliases for state properties
    return {
        fetchTaskListDetails: triggerApi,
        taskListDetailsData: apiState.data,
        isTaskListDetailsLoading: apiState.isLoading,
        isTaskListDetailsSuccess: apiState.isSuccess,
        isTaskListDetailsError: apiState.isError,
        TaskListDetailsError: apiState.error,
    }
}
